export enum ORGANIZATIONS {
	UBER_EATS = 'Uber Eats',
  UBER = 'Uber',
  AIRBNB = 'Airbnb',
  RAPPI = 'Rappi',
  CORNERSHOP = 'Cornershop',
  DIDI = 'Didi',
  MERCADO_ENVIOS = 'Mercado-Envios',
}